module.exports = __webpack_public_path__ + "img/03.306e5190.jpg";